import type { INavigationRoute } from '../../components/sidebar/NavigationRoutes'

export const commissionFinanceMenuChildren: INavigationRoute[] = [
  {
    name: 'finance-commissions',
    displayName: 'menu.commissions',
    gate: 'commission-rule',
    meta: {
      icon: 'paid',
    },
  },
]
